import { generateGuid } from '../../../../utils/typedHelper';

export interface DocumentSection {
    id: string;
    name: string;
    isLetterSection: boolean;
    index: number;
    isAvailableForBuyers: boolean;
}

export const EngagementAgreementSectionName = 'Engagement Agreements';

export const GenerateDocumentSectionList = (): DocumentSection[] => [
    {
        id: generateGuid(),
        name: EngagementAgreementSectionName,
        isLetterSection: true,
        index: 1,
        isAvailableForBuyers: false,
    },
    {
        id: generateGuid(),
        name: 'Stage 1 NDA (Identification)',
        isLetterSection: false,
        index: 2,
        isAvailableForBuyers: false,
    },
    {
        id: generateGuid(),
        name: 'Stage 2 NDA (data / restrictive covenants)',
        isLetterSection: false,
        index: 3,
        isAvailableForBuyers: false,
    },
    {
        id: generateGuid(),
        name: 'Informational Documents',
        isLetterSection: false,
        index: 4,
        isAvailableForBuyers: false,
    },
];
